// Deliberately NOT importing from ../dom.ts here: dom.ts is one monolithic
// module whose top-level code requireEl()-throws on ~140 ids as side
// effects of import. Importing even a single export from it would pull
// that entire graph into react-app.js a second time (it's already loaded
// once by app.js) - it happened once already (theme.ts -> dom.ts) and was
// fixed by not importing theme.ts from React either. This tiny, non-throwing
// lookup is the standing pattern for every phase's "reach into a
// still-vanilla trigger element" bridge instead.
export function getVanillaEl<T extends HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}
